import { AccountsEntity } from '@/domain/entities/account';
import { ChangeEmailPayload } from '@/domain/ports/account/payloads';
import { AccountsRepository } from '@/domain/ports/account/repositories';

export class ChangeEmailUseCase {
  constructor(private readonly repository: AccountsRepository) {}

  async run(payload: ChangeEmailPayload): Promise<AccountsEntity> {
    const account = await this.repository.changeEmail(payload);
    return account;
  }
}
